import React from 'react';
import '../less/fop-accounts.less';
import FAQStorybook from '@abank/abank-faq';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import tariffsData from '../enums/tariffs_data.json';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';
import hero_data from '../enums/hero_data.json';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import CalculatorNew from '../../../../../auxiliary-components/CalculatorNew';
import HowToBlockNew from '../../../../../auxiliary-components/shared/HowToBlockNew';
import howToBlockItemsData from '../enums/how_to_block_items.json';
import { Preloader } from 'MWComponents';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import { canUseDOM } from '../../../../../helpers/canUseDOM';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import additionalCardsData from '../enums/additional_cards_data.json';
import additionalCards2 from '../enums/additional_cards_2_data.json';
import additionalCards3Data from '../enums/additional_cards_3_data.json';
import FilesForDownloadNew from '../../../../../auxiliary-components/shared/FilesForDownloadNew';
import CardOrderModal from '../../../../../auxiliary-components/CardOrderModal';
import blue_card_img from '../img/blue_card_img.png';
import DOMPurify from 'utils/sanitize';
import reward_img from '../img/reward_img.png';
import hero_award_img_01 from '../img/hero_award_img_01.svg';
import hero_award_img_02 from '../img/hero_award_img_02.svg';
import { openAccountBusinessFOP, businessAllDigitalAwardLink, businessBannerAwardFop } from '../../../../../services/urls/urls';
import fop_reward_qr from '../img/fop_reward_qr.png';

const imagesMap = {
  how_to_block_img_1,
  how_to_block_img_2,
  how_to_block_img_3,
  hero_award_img_01,
  hero_award_img_02,
};

const urlsMap = {
  businessBannerAwardFop,
  businessAllDigitalAwardLink,
};

export default function template() {
  const page = 'fop-accounts-new';

  const isMobile = this.isViewportMobile();

  const model = this.getModel();

  const tabs = [{tab: 'tariffs', title: 'FOP_ACCOUNTS_NEW_TABS_INFO_TITLE_01'},
          {tab: 'calculator', title: 'FOP_ACCOUNTS_NEW_TABS_INFO_TITLE_02'}];

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  const hasUtm = this.state.utmParams
    && Object.keys(this.state.utmParams).some(key => key.startsWith('utm_'));
  const isMobileWithoutUtmMarks = !hasUtm && isMobile;

  const handlersMap = {
    toggleHeroModal: isMobileWithoutUtmMarks ? () => window.open(openAccountBusinessFOP, '_blank') : this.toggleModal,
    toggleRewardQrModal: isMobileWithoutUtmMarks ? () => window.open(openAccountBusinessFOP, '_blank') : () => this.openOverrideQrModal(fop_reward_qr)
  };

  const heroData = {
    ...hero_data,
    link: {
      ...hero_data.link,
      onClick: handlersMap[hero_data.link.onClick],
    },
    cards: hero_data.cards.map(card => ({
      ...card,
      img: imagesMap[card.img],
      href: urlsMap[card.href]
    }))
  };

  const resolveHandlers = ({ onClick, ...rest }) => ({
    ...rest,
    onClick: handlersMap[onClick]
  });

  const additionalCards = additionalCardsData.map(resolveHandlers);
  const additionalCards3 = additionalCards3Data.map(resolveHandlers);
  
  const howToBlockItems = howToBlockItemsData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  return (
    <div className="fop-accounts-new">
      <Hero
        data={heroData}
        img={hero_img}
        page={page}
      />
      <div className={`content${this.state.faqTab ? ' hidden' : ''}`}>
        <div className="blue-card">
          <div className="container">
            <h2 className="blue-card__title">{this.l10n('FOP_ACCOUNTS_NEW_BLUE_CARD_TITLE')}</h2>
            <div className="blue-card__body">
              <div className="blue-card__left">
                <img className="blue-card__image" src={blue_card_img} alt={this.l10n('FOP_ACCOUNTS_NEW_BLUE_CARD_TITLE')} />
              </div>
              <div className="blue-card__right">
                <div className="blue-card__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n('FOP_ACCOUNTS_NEW_BLUE_CARD_TEXT_01'))}}></div>
                <div className="blue-card__text">{this.l10n('FOP_ACCOUNTS_NEW_BLUE_CARD_TEXT_02')}</div>
                <div className="blue-card__text">{this.l10n('FOP_ACCOUNTS_NEW_BLUE_CARD_TEXT_03')}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="reward-block">
          <div className="container">
            <div className="reward-block__body">
              <h2 className="reward-block__title">{this.l10n('FOP_ACCOUNTS_NEW_REWARD_TITLE')}</h2>
              <div className="reward-block__row">
                <div className="reward-block__item item-reward-block item-reward-block_left">
                  <h3 className="item-reward-block__subtitle">{this.l10n('FOP_ACCOUNTS_NEW_REWARD_01_SUBTITLE')}</h3>
                  <div className="item-reward-block__body">
                    <img className="item-reward-block__img" src={reward_img} alt="reward img" />
                    <div className="item-reward-block__text">
                      <p><b>{this.l10n('FOP_ACCOUNTS_NEW_REWARD_01_TEXT_01')}</b></p>
                      <p>{this.l10n('FOP_ACCOUNTS_NEW_REWARD_01_TEXT_02')}</p>
                    </div>
                    <button className="item-reward-block__btn" onClick={handlersMap.toggleRewardQrModal}>{this.l10n('FOP_ACCOUNTS_NEW_REWARD_01_BTN')}</button>
                  </div>
                </div>
                <div className="reward-block__item item-reward-block item-reward-block_right">
                  <h3 className="item-reward-block__subtitle">{this.l10n('FOP_ACCOUNTS_NEW_REWARD_02_SUBTITLE')}</h3>
                  <div className="item-reward-block__body">
                    <div className="item-reward-block__text">
                      <div className="item-reward-block__top">
                        <p>{this.l10n('FOP_ACCOUNTS_NEW_REWARD_02_TOP_TEXT_01')}</p>
                        <p>{this.l10n('FOP_ACCOUNTS_NEW_REWARD_02_TOP_TEXT_02')}</p>
                        <ul>
                          <li>{this.l10n('FOP_ACCOUNTS_NEW_REWARD_02_TOP_LIST_01')}</li>
                          <li>{this.l10n('FOP_ACCOUNTS_NEW_REWARD_02_TOP_LIST_02')}</li>
                        </ul> 
                      </div>
                      <div className="item-reward-block__bottom">
                        {this.l10n('FOP_ACCOUNTS_NEW_REWARD_02_BOTTOM_TEXT')}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab}>
          <Tariffs
            items={tariffsData}
            title={'FOP_ACCOUNTS_NEW_CARDS_TARIFFS_TITLE'}
            btnLink={'/static/business/rko_tariffs.pdf'}
            btnText={'FOP_ACCOUNTS_NEW_CARDS_TARIFFS_BTN'}
          />
          {model.creditSum ? (
            <CalculatorNew model={model} type="limit" {...this.props} tab={this.state.tab}/>
          ) : this.state.calcError ? null : (canUseDOM ? <Preloader /> : null)}
        </Tabs>
        <div>
          <HowToBlockNew
            title={'FOP_ACCOUNTS_NEW_HOW_TO_TITLE'}
            items={howToBlockItems}
          />
          <AdditionalProduct
            items={additionalCards}
            className="additional-product_2"
          />
        </div>
        <QuestionsAdminNew
          widget={questionsWidget}
          toggleFaqTab={this.toggleFaqTab}
          title={'FOP_ACCOUNTS_NEW_QUESTIONS_TITLE'}
          loader={this.state.loader}
        />
        <AdditionalProduct
          items={additionalCards2}
          title={'FOP_ACCOUNTS_NEW_ADDITIONAL_PRODUCT_2_TITLE'}
        />
        <AdditionalProduct
          items={additionalCards3}
          title={'FOP_ACCOUNTS_NEW_ADDITIONAL_PRODUCT_3_TITLE'}
          className="additional-product_2"
        />
        <FilesForDownloadNew
          widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
          loader={this.state.loader}
        />
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('FOP_ACCOUNTS_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('FOP_ACCOUNTS_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
      {this.state.showModal &&
        <CardOrderModal closeModal={this.toggleModal} product={"fop"} isOpen={this.state.showModal} isBusiness={true} qrOverride={this.state.qrOverride}/>
      }
    </div>
  )
}
